import { createEntityCollectionStore } from '@recruitee/ngrx';

import { RemoteTemplate } from '../../../types';

const { actions, namespace, selectors, reducer } =
  createEntityCollectionStore<RemoteTemplate>()('RemoteTemplate');

export {
  actions as RemoteTemplateActions,
  namespace as RemoteTemplateNamespace,
  reducer as RemoteTemplateReducer,
  selectors as RemoteTemplateSelectors,
};
